import React from "react";
import { Button, Col, Row } from "react-bootstrap";

import classNames from "classnames";

import { useRosterContext } from "../contexts/Roster";
import { PlayerButtonsProps } from "../types/player";

import Loading from "../../../../../components/Loading";

const PlayerButtons = (props: PlayerButtonsProps): React.JSX.Element => {
    const { teamAtMaxSize, isAddingPlayer, setShowDeleteModal } = props;
    const { sending } = useRosterContext();

    return (
        <Row className={classNames("mt-3")} data-testid="playerButtons">
            <Col className={classNames("d-flex", "align-items-baseline")}>
                <Button
                    variant="primary"
                    type="submit"
                    disabled={teamAtMaxSize || sending}
                >
                    {isAddingPlayer ? "Add Player" : "Update Information"}
                </Button>
                {!isAddingPlayer && (
                    <Button
                        variant="danger"
                        type="button"
                        onClick={() => setShowDeleteModal(true)}
                        className={classNames("mx-2")}
                        disabled={sending}
                    >
                        Delete Player
                    </Button>
                )}

                {sending && <Loading className="mx-3 w-auto" />}
            </Col>
        </Row>
    );
};

export default PlayerButtons;
